/* De stappen op de productpagina worden na het laden door kopero-handleiding-variant.js vervangen door
   de versie voor de gekozen uitvoering (innerHTML). Daarmee verdwijnen de pijlen en de vervaagde rand die
   kopero-swipe op de rij had gezet. Zodra de inhoud wordt vervangen, laten we kopero-swipe de rijen
   opnieuw opzoeken; rijen die al klaar zijn slaat hij zelf over. */
(function () {
  var wrap = document.querySelector('[data-kopero-instructies]');
  if (!wrap || wrap.__keSwipeObs || !window.MutationObserver) return;
  wrap.__keSwipeObs = true;
  new MutationObserver(function () {
    document.dispatchEvent(new Event('shopify:section:load'));
  }).observe(wrap, { childList: true });
})();
